import {
  cityCostOfLivingData,
  CURRENCY_TO_SYMBOL,
  getTattooCost,
} from "$/data/tattoo_cost";
import { useAuth } from "$/util/auth";
import constants from "@blackink/core/categoryConstants";
import { getProductData, SIZES_BY_PLACEMENT } from "@blackink/core/productList";
import { ArrowOutward } from "@mui/icons-material";
import { Box, Button, Card, Chip, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function CreationDetailTempBanner(props) {
  const auth = useAuth();
  const { item, variant } = props;

  const product = getProductData(
    SIZES_BY_PLACEMENT[item.bodyPart]
      ? SIZES_BY_PLACEMENT[item.bodyPart][0]
      : "tattoo_2_2",
  );
  const userCity =
    auth.user && auth.user.city
      ? auth.user.city
          .toLowerCase()
          .replace(/\([^)]*\)/g, "")
          .trim()
      : ""; // remove text within parentheses and strip whitespace
  let cityIdx = -1;
  if (userCity && userCity.length > 0) {
    cityIdx = cityCostOfLivingData.findIndex((c) =>
      c.City.toLowerCase().includes(userCity),
    );

    if (cityIdx === -1) {
      const userCountry =
        auth.user && auth.user.country ? auth.user.country.toLowerCase() : "";
      cityIdx = cityCostOfLivingData.findIndex((c) =>
        c.Country.toLowerCase().includes(userCountry),
      );
    }
  }

  if (cityIdx === -1) {
    cityIdx = 11; // New York
  }

  const tattooCost = getTattooCost(
    cityIdx,
    SIZES_BY_PLACEMENT[item.bodyPart][0],
    item.style[0],
    1,
    1,
  );
  let currency = cityCostOfLivingData[cityIdx].Currency;
  currency = CURRENCY_TO_SYMBOL[currency] || currency + " $";

  return (
    <Card variant="outlined" sx={{ p: 2, mt: 3, mb: 2 }}>
      <Stack
        direction="column"
        // pb={2}
        // sx={{
        //   borderBottom: "1px solid",
        //   borderColor: "divider",
        // }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={2}
        >
          <Typography variant="h6">
            Permanent{" "}
            {constants.GENERIC_SIZES.includes(item.bodyPart)
              ? `${product.width}x${product.height}"`
              : constants.BODY_PART_DESC[item.bodyPart].name}{" "}
            Tattoo
          </Typography>

          <Button
            component={Link}
            to="/tattoo-cost-calculator"
            variant="text"
            color="inherit"
            size="small"
            endIcon={<ArrowOutward />}
            sx={{ whiteSpace: "nowrap" }}
          >
            Adjust Calc
          </Button>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            overflowX: "auto",
            scrollbarWidth: "none",
          }}
        >
          <Chip size="small" label={cityCostOfLivingData[cityIdx].City} />
          <Chip size="small" label="Avg. Artist Experience" />
        </Stack>

        <Typography variant="body2" sx={{ mt: 1 }}>
          Calculate the cost of a permanent tattoo based on this design.
        </Typography>
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Box flex={1}>
            <Typography variant="overline">Session Cost</Typography>

            <Typography variant="h6">
              {currency}
              {tattooCost.min} - {currency}
              {tattooCost.max}
            </Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="overline">Tip (15 - 20%)</Typography>
            <Typography variant="h6">
              {currency}
              {tattooCost.tipMin} - {currency}
              {tattooCost.tipMax}
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2} py={2}>
          <Box mt={2} flex={1}>
            <Typography variant="overline">Total Est. Cost</Typography>
            <Typography variant="h5" color="primary">
              {currency}
              {tattooCost.total}
            </Typography>
          </Box>

          <Box flex={1}>
            <Typography variant="overline">
              {tattooCost.useSessions ? "# of Sessions" : "# of Hours"}
            </Typography>
            <Typography variant="h5">
              {tattooCost.useSessions ? tattooCost.avgSessions : tattooCost.avgHours}{" "}
              {tattooCost.useSessions ? "Session(s)" : "Hour(s)"}
            </Typography>
          </Box>
        </Stack>
      </Stack>
      {/* <Stack direction="row" spacing={2} alignItems="top" py={2}>
        <Box>
          <Typography variant="h6">No-Regret Temporary Tattoos</Typography>
          <Typography variant="h5" color="primary">
            ${product.price / 100} for {product.width}x{product.height}
            &quot;
          </Typography>

          <Typography variant="body2" sx={{ mb: 2 }}>
            Does this one look like a dream tattoo? :D <br />
            Take it for a spin for 2 weeks. It looks like the real thing without the
            commitment. We only use black ink, converting all designs to blackwork or
            dotwork.
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to={getCreationSingleURLv2(item, variant)}
            sx={{ minWidth: 120, ...gradientGrainStyling }}
          >
            ORDER NOW
          </Button>
        </Box>
        <Box
          sx={{
            maxWidth: 100,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#F4F4F4",
              p: 1,
              borderRadius: 2,
            }}
          >
            <ImageCanvasSimple
              imageUrl={getImageUrl(item.imagePaths[variant])}
              width={constants.BODY_PART_DESC[item.bodyPart].width}
              height={constants.BODY_PART_DESC[item.bodyPart].height}
              threshold={0.25}
              minBrightness={0}
              maxBrightness={250}
              shadingPattern="simple"
            />
          </Box>
        </Box>
      </Stack> */}
    </Card>
  );
}
